export function proposalStatus (proposal, publicKey) {
  const yes_voters = proposal.votes.ayes.map(y => y[0])
  const no_voters = proposal.votes.nays.map(n => n[0])
  const yes_votes = proposal.votes.ayes.reduce((p, c) => p + c[1], 0)
  const no_votes = proposal.votes.nays.reduce((p, c) => p + c[1], 0)
  if (yes_voters.includes(publicKey) || proposal.votes.threshold === 1) {
    proposal.voting_status = 'Approved'
  } else if (no_voters.includes(publicKey)) {
    proposal.voting_status = 'Rejected'
  } else {
    proposal.voting_status = 'Pending'
  }
  if (yes_votes >= proposal.votes.threshold) {
    proposal.status = 'Approved'
  } else if (no_votes + yes_votes >= proposal.votes.threshold) {
    proposal.status = 'Rejected'
  } else {
    proposal.status = 'InProgress'
  }
}
